import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIIllustration from 'UIComponents/image/UIIllustration'; // @ts-expect-error Untyped import

import ContentControlWrapper from '../../../components/ContentControlWrapper'; // @ts-expect-error Untyped import

import ContentViewport from '../../../components/ContentViewport';
import ExamTimer from './ExamTimer';
import { useFullTrack } from '../../tracks';
import { useMostRecentExamAttempt } from '../../exams';
import { useCallback } from 'react';
import { useResumeExam, useValidateExam } from '../../exams';
import UsageTracker from '../../../utils/UsageTracker';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
const BASE_CLASS_NAME = 'exam-resume-screen';

const ExamResumeScreen = ({
  trackId
}) => {
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId));
  const {
    track
  } = useFullTrack(trackId);
  const [validateExam, {
    validateExamLoading,
    validateExamError
  }] = useValidateExam();
  const [resumeExam, {
    resumeExamLoading,
    resumeExamError
  }] = useResumeExam();
  const totalQuestionCount = track && track.exam ? track.exam.length : 0;
  const answeredQuestionCount = mostRecentExamAttempt ? mostRecentExamAttempt.questionSubmissions.length : 0;
  const remainingQuestionCount = totalQuestionCount - answeredQuestionCount;
  const handleResume = useCallback(() => {
    if (!mostRecentExamAttempt) return null;

    if (answeredQuestionCount >= totalQuestionCount) {
      return validateExam(Number(trackId), mostRecentExamAttempt.id).then(() => {
        UsageTracker.track('examInteraction', {
          action: 'completed',
          examId: track && track.exam.id,
          examLength: mostRecentExamAttempt.questions.length,
          trackId,
          trackName: track && track.name,
          examAttemptId: mostRecentExamAttempt.id
        });
      });
    }

    UsageTracker.track('examInteraction', {
      action: 'resume',
      examId: track && track.exam.id,
      examLength: mostRecentExamAttempt.questions.length,
      trackId,
      trackName: track && track.name,
      examAttemptId: mostRecentExamAttempt.id
    });
    return resumeExam(Number(trackId), mostRecentExamAttempt.id);
  }, [answeredQuestionCount, mostRecentExamAttempt, resumeExam, totalQuestionCount, track, trackId, validateExam]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(ContentViewport, {
      wrapperClassName: `${BASE_CLASS_NAME}__content-viewport`,
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        className: `${BASE_CLASS_NAME}__illustration`,
        name: "nps-question",
        width: 150
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'learningCenter.exams.resume.heading'
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'learningCenter.exams.resume.remainingQuestionCount',
          options: {
            count: remainingQuestionCount
          }
        }), /*#__PURE__*/_jsx(ExamTimer, {
          trackId: trackId
        })]
      })]
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      className: `${BASE_CLASS_NAME}__content-control`,
      children: /*#__PURE__*/_jsx(UILoadingButton, {
        failed: !!validateExamError || !!resumeExamError,
        loading: validateExamLoading || resumeExamLoading,
        onClick: handleResume,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'learningCenter.exams.resume.resumeExam'
        })
      })
    })]
  });
};

export default ExamResumeScreen;